import script from "./LeftRightLine.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftRightLine.vue?vue&type=script&setup=true&lang=js"

export default script